import React, {useContext, useEffect, useState} from "react";
import {DataTable, SkeletonBodyText, Modal, TextContainer} from "@shopify/polaris";
import {DateTime} from "luxon";
import _ from 'lodash';
import {ShopContext} from "../App";
import axios from "../axios";

const CheckoutAutomations = ({checkoutId}) => {
    const config = useContext(ShopContext);
    const [active, setActive] = useState(false);
    const [loading, setLoading] = useState(false);
    const [log, setLog] = useState([]);

    useEffect(() => {
        if (active) {
            setLoading(true);
            axios.get(`/checkouts/automation-logs/${checkoutId}`, {
                "headers": {
                    shopOrigin: config.shopOrigin,
                    xShopHost: config.host,
                }
            }).then((response) => {
                let allData = _.get(response, 'logs', []);
                let messageLogs = [];
                if (allData.length > 0) {
                    allData.forEach((data) => {
                        let processedData = [];
                        processedData.push(data.message);
                        processedData.push(data.status);
                        processedData.push(DateTime.fromMillis(parseInt(data.created_at)).toLocaleString(DateTime.DATETIME_SHORT));
                        messageLogs.push(processedData)
                    });
                }
                setLog(messageLogs)
                setLoading(false);
            }).catch(() => {
                setLoading(false);
            });
        }
    }, [active, checkoutId, config])
    return (
        <div>
            <a href="#" onClick={() => {
                setActive(true)
            }}>View details ></a>
            <Modal
                instant
                open={active}
                onClose={() => {
                    setActive(false)
                }}
                title="Automation log"
            >
                <Modal.Section>
                    {loading && <SkeletonBodyText lines={6}/>}
                    {!loading && <TextContainer>
                        <DataTable
                            columnContentTypes={[
                                'text',
                                'text',
                                'text',
                            ]}
                            headings={[
                                'Message',
                                'Status',
                                'Sent date'
                            ]}
                            rows={log}
                            footerContent={log.length > 0 ? `Showing ${log.length} results` : 'No log found for the checkout'}
                        />
                    </TextContainer>}
                </Modal.Section>
            </Modal>
        </div>
    );
}
export default CheckoutAutomations;
